import { type TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { CardImg } from '@sorare/core/src/components/card/CardImg';

import { PlaceholderSlot } from '@sorare/marketplace/src/components/commonCard/RevealPackCardsDialog/CollectionAnimationV2/CollectionAnimationClub/PlaceholderSlot';

import type { CollectionSlot_userCardCollectionSlot } from './__generated__/index.graphql';

const Root = styled.div``;

type Props = {
  userCardCollectionSlot: Nullable<CollectionSlot_userCardCollectionSlot>;
  small?: boolean;
};

export const CollectionSlot = ({
  userCardCollectionSlot,
  small = false,
}: Props) => {
  const { highlightedCardCollectionCard, cardCollectionCardsCount } =
    userCardCollectionSlot || {};
  const { anyCard } = highlightedCardCollectionCard || {};
  if (cardCollectionCardsCount === 0) {
    return <PlaceholderSlot slot={userCardCollectionSlot} small={small} />;
  }
  return (
    <Root>
      {!!anyCard?.pictureUrl && (
        <CardImg src={anyCard.pictureUrl} alt="" width={160} />
      )}
    </Root>
  );
};

CollectionSlot.fragments = {
  userCardCollectionSlot: gql`
    fragment CollectionSlot_userCardCollectionSlot on UserCardCollectionSlot {
      slug
      cardCollectionCardsCount
      highlightedCardCollectionCard {
        id
        anyCard {
          slug
          pictureUrl
        }
      }
      ...PlaceholderSlot_userCardCollectionSlot
    }
    ${PlaceholderSlot.fragments.userCardCollectionSlot}
  ` as TypedDocumentNode<CollectionSlot_userCardCollectionSlot>,
};
